import { Button, Flex, FlexProps } from "@mantine/core";
import { useScrollIntoView } from "@mantine/hooks";
import { Link } from "react-router-dom";

interface IProps extends FlexProps {
  variant?: string;
  button: string;
  buttonTo: string;
  button2: string;
  buttonTo2: string;
}

const ButtonSignUpForFree: React.FC<IProps> = ({
  variant,
  button,
  buttonTo,
  button2,
  buttonTo2,
  ...props
}) => {
  const { scrollIntoView } = useScrollIntoView({ duration: 0 });

  return (
    <Flex
      gap={{ base: 16, 630: 32 }}
      wrap={{ base: "wrap", 630: "nowrap" }}
      data-aos={"fade-top"}
      justify="center"
      align="center"
      direction={{ base: "column-reverse", 796: "row" }}
      w="100%"
      {...props}
    >
      <Button
        onClick={() => {
          scrollIntoView({ alignment: "start" });
        }}
        component={Link}
        to={buttonTo}
        variant={variant ? variant + "Outline" : "primaryOutline"}
        maw={{ base: 380, 991: 276 }}
        w="100%"
      >
        {button}
      </Button>
      <Button
        onClick={() => {
          scrollIntoView({ alignment: "start" });
        }}
        component={Link}
        to={buttonTo2}
        variant={variant ? variant : "primary"}
        maw={{ base: 380, 991: 276 }}
        w="100%"
      >
        {button2}
      </Button>
    </Flex>
  );
};
export default ButtonSignUpForFree;
